import React from "react";
import { Controls, FormGroup, IFormStyles, useFormStyles } from "../.";
import { FormGroupProps } from "../misc/formGroup";

interface FormRadioProps extends Controls.ControlRadioProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    isOptional?: boolean | undefined;
    tooltip?: string | undefined;
}

const ComponentProps = (props: FormRadioProps): Controls.ControlRadioProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormRadioProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: "radio",

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormRadio: React.FC<Controls.ControlRadioProps> = (props) => {
    const styles: IFormStyles = useFormStyles();

    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlRadio {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};